import { Mixpanel } from '../services/mixpanel';

window.MixpanelService = Mixpanel;